<template>
    <v-row justify="end" align="end" class="ma-n4 flex-nowrap" :class="{ 'mt-n8': isItemSequent }">
        <v-col cols="auto" class="pa-4" :style="{ opacity: isTimeSequent ? 0 : 1 }">
            <span class="font-size-10 ml-4">{{ time }}</span>
        </v-col>
        <v-col cols="auto" class="pa-4" style="max-width: calc(100% - 36px)">
            <v-card color="primary lighten-5" flat min-height="36">
                <v-card-text class="py-8 px-12 font-size-14">
                    <div v-html="html"></div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import xss from "xss";
import dayjs from "@/plugins/vue-dayjs";
import { mapState } from "vuex";
import { initLectureChatMessage } from "@/store/lecture/chat/chat.inits";

export default {
    props: {
        index: { type: Number, default: 0 },
        message: { type: Object, default: initLectureChatMessage },
    },
    computed: {
        ...mapState("lecture/chat", ["messages"]),
        time() {
            return dayjs(this.message?.createdAt).format("HH:mm");
        },
        isItemSequent() {
            if (this.index == 0) return false;
            const prev = this.messages[this.index - 1];
            return prev?.type == "user";
        },
        isTimeSequent() {
            if (this.index == this.messages.length - 1) return false;

            const next = this.messages[this.index + 1];
            if (next?.type != "user") return false;

            return dayjs(next?.createdAt).format("HH:mm") == this.time;
        },
        html() {
            let regex = /(https?:\/\/[^\s]+)/g;
            return xss(this.message.message, { allowList: [] }).replaceAll(regex, (href) => `<a href="${href}" target="_blank">${href}</a>`);
        },
    },
};
</script>

<style></style>
